module.exports = __webpack_public_path__ + "static/img/comparativo-ações.dfe8cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comparativo-ações.png
// module id = I0uj
// module chunks = 1